const type = 'SET_STATEMENTS_LOADING';

const setStatementsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setStatementsLoading;
